var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStopCircle = function SvgStopCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    clipPath: "url(#stop-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.333 6.4c0-.373 0-.56.073-.703a.67.67 0 0 1 .291-.291c.143-.073.33-.073.703-.073h3.2c.373 0 .56 0 .703.073a.67.67 0 0 1 .291.291c.073.143.073.33.073.703v3.2c0 .373 0 .56-.073.703a.67.67 0 0 1-.291.291c-.143.073-.33.073-.703.073H6.4c-.373 0-.56 0-.703-.073a.67.67 0 0 1-.291-.291c-.073-.143-.073-.33-.073-.703z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "stop-circle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgStopCircle;